module.exports = __webpack_public_path__ + "static/img/widget-7.ba7f5a7a.png";